import gql from 'graphql-tag';

const gameVersion = gql`
    query Version {
        version
    }
`;

export default gameVersion;
